module.exports = __webpack_public_path__ + "img/top-merit-5.3f667fc1.jpg";